import type { RequestOptions } from "@/lib/request/request-options";

export function addQueryParameters(
  url: URL,
  query: RequestOptions["query"],
): void {
  for (const [key, value] of Object.entries(query ?? {})) {
    if (value !== undefined) {
      url.searchParams.set(key, String(value));
    }
  }
}
